(() => {
  const paletteClass = (source = '') => {
    let decodedSource = source;
    try { decodedSource = decodeURIComponent(source); } catch (error) { /* Keep the original source. */ }
    const value = decodedSource.toLocaleLowerCase('fr');
    if (value.includes('découverte') || value.includes('decouverte')) return 'discovery';
    if (value.includes('équilibre') || value.includes('équilibré') || value.includes('equilibre')) return 'equilibre';
    if (value.includes('ristretto')) return 'ristretto';
    if (value.includes('lungo')) return 'lungo';
    if (value.includes('décaf') || value.includes('decaf')) {
      return value.includes('dosette') || value.includes('senseo') ? 'decafeine-dosette' : 'decafeine-capsule';
    }
    if (value.includes('espresso') || value.includes('intense')) return 'espresso';
    if (value.includes('classique')) return 'classique';
    if (value.includes('corsé') || value.includes('corse')) return 'corse';
    if (value.includes('doux')) return 'doux';
    return 'signature';
  };

  const applyPalette = (root = document) => {
    const items = root.matches?.('[data-legal-product-palette-source]')
      ? [root]
      : [...root.querySelectorAll?.('[data-legal-product-palette-source]') || []];
    items.forEach((item) => {
      if (item.dataset.legalPaletteApplied === 'true') return;
      const key = paletteClass(item.dataset.legalProductPaletteSource);
      item.classList.add('legal-product-palette', `legal-product-palette--${key}`, `legal-home-product--palette-${key}`);
      item.dataset.legalPaletteApplied = 'true';
    });
  };

  window.LegalProductPaletteApply = applyPalette;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => applyPalette());
  } else {
    applyPalette();
  }

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) applyPalette(node);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
